import { SET_MINER_STATUS } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_MINER_STATUS:
      return action.payload;
    default:
      return state;
  }
};
